import React, { useEffect, useState, useRef } from 'react';
import { Col, Row, Space, Divider } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import ReactImageMagnify from 'react-image-magnify';

import * as S from './styles';

export function CarouselImage({
  data,
  titulo,
  indexImg,
  miniatura = false,
}) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageSizes, setImageSizes] = useState();
  const carouselRef = useRef([]);

  useEffect(() => {
    if (data && data[0]) {
      carouselRef.current = carouselRef.current.slice(0, data.length);

      setSelectedImageIndex(indexImg || 0);
      setSelectedImage(data[indexImg || 0]);
    }
  }, [data]);

  const handleSelectedImage = (image, index) => {
    setSelectedImage(image);
    setSelectedImageIndex(index);
  };

  const backImage = () => {
    const newIndex =
      selectedImageIndex > 0 ? selectedImageIndex - 1 : selectedImageIndex;
    setSelectedImageIndex(newIndex);
    setSelectedImage(data[newIndex]);
  };

  const nextImage = () => {
    const newIndex =
      selectedImageIndex < data.length - 1
        ? selectedImageIndex + 1
        : selectedImageIndex;
    setSelectedImageIndex(newIndex);
    setSelectedImage(data[newIndex]);
  };

  return (
    <Col
      justify="center"
      style={{
        marginBottom: 12,
      }}
      sm={24}
      xs={24}
      md={24}
      lg={24}
    >
      <Row>
        <S.TitleImage>{titulo || ''}</S.TitleImage>
        <Divider
          style={{
            margin: '8px 0',
            border: '1px solid #BDBDBD',
          }}
        />
      </Row>
      <S.Container>
        {selectedImage?.url && (
          <S.ContainerImage
            ref={el => {
              if (el) {
                const width = el.offsetWidth;
                const height = el.offsetHeight;
                if (!imageSizes) {
                  setImageSizes({ width, height });
                }
              }
            }}
          >
            {selectedImageIndex > 0 && (
              <S.ButtomActionGo
                onClick={backImage}
                left
                bColor={selectedImageIndex === 0}
              >
                <LeftOutlined />
              </S.ButtomActionGo>
            )}
            {imageSizes && (
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: 'selectedImage?.url',
                    isFluidWidth: true,
                    src: selectedImage?.url,
                    width: imageSizes?.width,
                    height: imageSizes?.height,
                  },
                  largeImage: {
                    src: selectedImage?.url,
                    width: 1200,
                    height: 1800,
                  },
                  enlargedImagePosition: 'over',
                }}
              />
            )}
            {selectedImageIndex < data.length - 1 && (
              <S.ButtomActionGo onClick={nextImage} right>
                <RightOutlined />
              </S.ButtomActionGo>
            )}
          </S.ContainerImage>
        )}
        {miniatura && (
          <S.ContainerMiniatures>
            <S.CarouselImages>
              {data.length &&
                data?.map((item, index) => (
                  <Space
                    style={{
                      margin: '8px 22px 8px 0',
                      cursor: 'pointer',
                      border:
                        selectedImageIndex === index
                          ? 'solid 2px #24A95D'
                          : 'none',
                      backgroundColor:
                        selectedImageIndex === index ? '#24A95D' : '#fff',
                      borderRadius: 8,
                      padding: 2,
                    }}
                    onClick={() => handleSelectedImage(item, index)}
                    key={index}
                  >
                    <S.ImageMiniature
                      src={item?.url}
                      ref={el => (carouselRef.current[index] = el)}
                    />
                  </Space>
                ))}
            </S.CarouselImages>
          </S.ContainerMiniatures>
        )}
      </S.Container>
    </Col>
  );
}
